import { render, staticRenderFns } from "./AppTable.vue?vue&type=template&id=6a50eadf&scoped=true&"
import script from "./AppTable.vue?vue&type=script&lang=js&"
export * from "./AppTable.vue?vue&type=script&lang=js&"
import style0 from "./AppTable.vue?vue&type=style&index=0&id=6a50eadf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a50eadf",
  null
  
)

export default component.exports